import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/alt-supply", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/alt-supply/csv", params);
};

const get = id => {
  return restApi.get(`/api/alt-supply/${id}`);
};

const upsert = data => {
  return restApi.post("/api/alt-supply/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/alt-supply/${ids}`);
};

const alternateSupplyService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove
};

export default alternateSupplyService;
